// extracted by mini-css-extract-plugin
export default {"alumniContainer":"Alumni_alumniContainer__ZRfeT","alumniWaveUpper":"Alumni_alumniWaveUpper__fE7cr","alumniWaveLower":"Alumni_alumniWaveLower__EICqB"};